import React from "react";
import { Chip } from "@mui/material";
import styled from "@emotion/styled";

const StyledSkillChip = styled(Chip, { shouldForwardProp: (prop) => prop !== "highlight" })(({ theme, highlight }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: highlight ? theme.palette.warning.main : theme.palette.inverted.main,
    color: highlight ? theme.palette.warning.contrastText : theme.palette.inverted.contrastText,
}));

const SkillChip = ({ skill, highlight = false }) => {

    return (
        <StyledSkillChip size="small" highlight={highlight} label={`Skill: ${skill || "Not Set"}`} />
    );
};

export default SkillChip;